module.exports = __webpack_public_path__ + "media/drop_off_bookings/validate_drop_off_bookings-1e8c0207.png";